export default "__VITE_ASSET__9UyQWOnt__"